<template>
  <div class="form-container">
    <el-form :model="form" label-position="top">
      <el-form-item :label="field.name" v-for="field in fields" :key="field.key">
        <component :is="field.ctrl" v-model="form[field.key]" :options="field.options"
          :placeholder="field.placeholder" :multiple="field.multiple" @change="field.onChange"
          @item-click="field.onItemClick" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts" setup>
import { Field } from '@/types'
import { toRef } from 'vue';

const props = defineProps<{
  fields: Field[]
  modelValue: { [key: string]: any }
}>()
const { fields } = props
const form = toRef(props, 'modelValue')
</script>
<style lang="stylus" scoped>
.form-container {
  padding: 16px;
}
</style>